// import React, { useRef, useEffect } from "react";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import "./Download.css";
// import Image from "../../../../assets/images/magic-health-logo.png"
// const Download = ({ data, onDownloadComplete }) => {
//   console.log(data);
//   const downloadRef = useRef();

//   useEffect(() => {
//     handleDownloadPDF();
//   }, []);

//   const handleDownloadPDF = () => {
//     const input = downloadRef.current;

//     html2canvas(input).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "mm", "a4");
//       const imgWidth = 210;
//       const pageHeight = 295;
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;
//       let heightLeft = imgHeight;
//       let position = 0;

//       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;

//       while (heightLeft > 0) {
//         position = heightLeft - imgHeight;
//         pdf.addPage();
//         pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//         heightLeft -= pageHeight;
//       }

//       const pdfBlob = pdf.output("blob");
//       const pdfUrl = URL.createObjectURL(pdfBlob);
//       window.open(pdfUrl, "_blank");

//       // Invoke callback to notify that download is complete
//       if (onDownloadComplete) {
//         onDownloadComplete();
//       }
//     });
//   };

//   return (
//     <div ref={downloadRef} className="issue-details-container">
//       {/* Header Section */}
//       <div className="header-download">
//         <div className="logo-section">
//           <img src={Image} alt="Magic Health Logo" className="logo" />
//         </div>
//         <div className="issue-info">
//           <h3># Issue - {data.issueId}</h3>
//           <p>
//             Call Category: <span className="category">{data.callCategory}</span>
//           </p>
//           <p>
//             Status: <span className="status">{data.status}</span>
//           </p>
//         </div>
//       </div>

//       {/* Customer Info */}
//       <div className="customer-info">
//         <p>
//           <strong>Customer's Name:</strong> {data.customerName}
//         </p>
//         <p>
//           <strong>Agent's Name:</strong> {data.agentName}
//         </p>
//       </div>

//       {/* Issue Summary */}
//       <div className="issue-summary">
//         <h4>Issue Summary</h4>
//         <h5>Change In Subscription</h5>
//         <p>{data.changeSubscription}</p>
//       </div>

//       {/* Notes */}
//       <div className="notes">
//         <h4>Notes</h4>
//         {data.notes.map((note, index) => (
//           <div key={index}>
//             <p>
//             <strong>
//           {note.agentName} -{" "}
//           {new Date(note.createdOn).toLocaleDateString("en-GB", {
//             day: "numeric",
//             month: "long",
//             year: "numeric",
//           })}
//         </strong>
//             </p>
//             <p>{note.notes}</p>
//           </div>
//         ))}
//       </div>

//       {/* History */}
//       <div className="history">
//         <h4>History</h4>
//         {data.history.map((historyItem, index) => (
//           <div key={index}>
//             <p>
//             <strong>
//           {historyItem.agentName} -{" "}
//           {new Date(historyItem.createdOn).toLocaleDateString("en-GB", {
//             day: "numeric",
//             month: "long",
//             year: "numeric",
//           })}
//         </strong>
//             </p>
//             <p>{historyItem.notes}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Download;

import React, { useRef, useEffect } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./Download.css";
import UIConfig from "../../../../common/constants/UIConfig";

const Download = ({ data, onDownloadComplete }) => {
  const downloadRef = useRef();
  console.log(data);
  useEffect(() => {
    const timer = setTimeout(() => {
      handleDownloadPDF();
    }, 500); // Add a small delay to ensure rendering is complete

    return () => clearTimeout(timer); // Cleanup to prevent multiple calls
  }, []);

  // Define inline styles for each status
  const getStatusStyle = () => {
    switch (data.status?.toLowerCase().trim()) {
      case "yes":
        return { color: "#ff5151", backgroundColor: "#ffefe7" }; // Red for Open
      case "in-progress":
        return { color: "#3786f1", backgroundColor: "#e8f0fb" }; // Blue for In Progress
      case "closed":
        return { color: "#ee61cf", backgroundColor: "#fdebf9" }; // Green for Closed
      default:
        return { color: "#f5f5f5", backgroundColor: "#000" }; // Default grey
    }
  };

  // Define display text for the status
  const getStatusText = () => {
    switch (data.status?.toLowerCase().trim()) {
      case "yes":
        return "Open";
      case "in-progress":
        return "In Progress";
      case "closed":
        return "Closed";
      default:
        return "Unknown"; // Default text
    }
  };

  // const handleDownloadPDF = () => {
  //   const input = downloadRef.current;

  //   // Force a minimum height to ensure full A4 size
  //   input.style.minHeight = "1122px"; // A4 height in pixels at 96 DPI

  //   html2canvas(input, { scrollY: -window.scrollY ,

  //   }).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("p", "mm", "a4");

  //     const imgWidth = 210;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

  //     // Save or open the PDF
  //     pdf.save("issue-details.pdf");

  //     if (onDownloadComplete) {
  //       onDownloadComplete();
  //     }
  //   });
  // };

  const handleDownloadPDF = () => {
    const input = downloadRef.current;
    // Force a minimum height to ensure full A4 size
    input.style.minHeight = "1122px"; // A4 height in pixels at 96 DPI

    // Apply a short delay to allow rendering corrections
    setTimeout(() => {
      html2canvas(input, {
        scale: 3, // Use high scale for better resolution
        useCORS: true,
        allowTaint: false,
        backgroundColor: "#FFFFFF", // Explicit background fix
        logging: false,
        width: input.scrollWidth, // Capture full width
        height: input.scrollHeight, // Capture full height
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const imgWidth = 210; // A4 width in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        pdf.save("issue-details.pdf");

        if (onDownloadComplete) {
          onDownloadComplete();
        }
      });
    }, 500); // Short delay to allow styles to apply
  };

  return (
    <div ref={downloadRef} className="issue-details-container">
      {/* Header Section */}
      <div className="sidebar-le">
        <div className="sidebar-co" />
      </div>
      <div className="header-download">
        <div className="Epicured_Logo">
          <img src={UIConfig.branding.logo} alt="Epicured Logo" className="img" />
        </div>
        <div className="issue-id">
          <h3># Issue - {data?.issueId || "N/A"}</h3>
        </div>
        <div className="customer-info">
          <p>
            <strong className="name-cust">Customer's Name:</strong>{" "}
            <span className="name-work">{data?.customerName || "Unknown"}</span>
          </p>
        </div>
        <div className="pdf-div">
          <div className="agent-info">
            <p>
              <strong className="name-cust">Agent's Name:</strong>{" "}
              {data?.agentName || "Unknown"}
            </p>
          </div>
          <div className="call-category-status">
            <p>
              Call Category:{" "}
              <span className="category">{data?.callCategory || "N/A"}</span>
            </p>
            <div className="pdf-status">
              <p>Status: </p>{" "}
              <span
                className="status-download"
                style={{
                  ...getStatusStyle(),
                  borderRadius: "8px",
                  fontWeight: "550",
                  display: "inline-block",
                  fontSize: "11px",
                  // lineHeight: "16px",
                  // marginTop: "-4px",
                  // position: "relative",
                  // left: "-109px",
                }}
              >
                {data?.status === "Yes" && "Open"}
                {data?.status === "In-Progress" && "In Progress"}
                {data?.status === "Closed" && "Closed"}
                {!["Yes", "In-Progress", "Closed"].includes(data?.status) &&
                  "Unknown"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Issue Summary */}
      {/* <div className="issue-summary">
        <h4>Issue Summary</h4>
        <h5>Change In Subscription</h5>
        <p>{data?.changeSubscription || "No information available"}.</p>
      </div> */}

      {/* Notes Section */}
      <div className="notes">
        <h4>Notes</h4>
        {(data?.notes || []).length > 0 ? (
          data.notes.map((note, index) => (
            <div key={index}>
              <p>
                <strong>
                  {note?.agentName || "Unknown"} -{" "}
                  {note?.createdOn
                    ? new Date(note.createdOn).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                    : "Date Not Available"}
                </strong>
              </p>
              <p>{note?.notes || "No notes available"}</p>
            </div>
          ))
        ) : (
          <p>No notes available.</p>
        )}
      </div>

      {/* History Section */}
      <div className="history">
        <h4>History</h4>
        {(data?.history || []).length > 0 ? (
          data.history.map((historyItem, index) => (
            <div key={index}>
              <p>
                <strong>
                  {historyItem?.agentName || "Unknown"} -{" "}
                  {historyItem?.createdOn
                    ? new Date(historyItem.createdOn).toLocaleDateString(
                        "en-GB",
                        {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        }
                      )
                    : "Date Not Available"}
                </strong>
              </p>
              <p>{historyItem?.notes || "No history details available"}</p>
            </div>
          ))
        ) : (
          <p>No history available.</p>
        )}
      </div>
    </div>
  );
};

export default Download;

// import React, { useRef, useEffect } from "react";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import "./Download.css";
// import Image from "../../../../assets/images/magic-health-logo.png"; // Adjust the image path based on your project
// import HealthrageousLogo from "../../../../assets/images/HealthrageousLogo.png";

// const Download = ({ data, onDownloadComplete }) => {
//   const downloadRef = useRef();

//   useEffect(() => {
//     if (data) {
//       handleDownloadPDF();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [data]);

//   const handleDownloadPDF = () => {
//     const input = downloadRef.current;

//     if (!input) {
//       console.error("Download reference is null.");
//       return;
//     }

//     html2canvas(input, { scale: 2 })
//       .then((canvas) => {
//         const imgData = canvas.toDataURL("image/png");
//         const pdf = new jsPDF("p", "mm", "a4");
//         const imgWidth = 210;
//         const pageHeight = 295;
//         const imgHeight = (canvas.height * imgWidth) / canvas.width;
//         let heightLeft = imgHeight;
//         let position = 0;

//         pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//         heightLeft -= pageHeight;

//         while (heightLeft > 0) {
//           position = heightLeft - imgHeight;
//           pdf.addPage();
//           pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//           heightLeft -= pageHeight;
//         }

//         const pdfBlob = pdf.output("blob");
//         const pdfUrl = URL.createObjectURL(pdfBlob);
//         window.open(pdfUrl, "_blank");

//         if (onDownloadComplete) {
//           onDownloadComplete();
//         }
//       })
//       .catch((error) => {
//         console.error("Error generating PDF:", error);
//       });
//   };

//   if (!data) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div ref={downloadRef} className="issue-details-container">
//       {/* Sidebar */}
//       <div className="sidebar-le">
//         <div className="sidebar-co" />
//       </div>

//       {/* Header Section */}
//       <div className="header-download">
//         <div className="HealthrageousLogo">
//           <img src={HealthrageousLogo} alt="Magic Health Logo" className="img" />
//         </div>
//         <div className="issue-id">
//           <h3># Issue - {data.issueId || "N/A"}</h3>
//         </div>
//         <div className="call-category-status">
//           <p>
//             Call Category: <span className="category">{data.callCategory || "N/A"}</span>
//           </p>
//           <p>
//             Status: <span className="status">{data.status || "N/A"}</span>
//           </p>
//         </div>
//       </div>

//       {/* Customer and Agent Info */}
//       <div className="customer-info">
//         <p>
//           <strong>Customer's Name:</strong> {data.customerName || "N/A"}
//         </p>
//       </div>
//       <div className="agent-info">
//         <p>
//           <strong>Agent's Name:</strong> {data.agentName || "N/A"}
//         </p>
//       </div>

//       {/* Issue Summary */}
//       <div className="issue-summary">
//         <h4>Issue Summary</h4>
//         <h5>Change In Subscription</h5>
//         <p>{data.issueSummary || "No summary provided."}</p>
//       </div>

//       {/* Notes Section */}
//       <div className="notes">
//         <h4>Notes</h4>
//         {Array.isArray(data.notes) && data.notes.length > 0 ? (
//           data.notes
//             .filter((note) => note !== null && note !== undefined)
//             .map((note, index) => (
//               <div key={index}>
//                 <p>
//                   <strong>
//                     {note.agentName || "Unknown Agent"} -{" "}
//                     {note.createdOn
//                       ? new Date(note.createdOn).toLocaleDateString("en-GB", {
//                           day: "numeric",
//                           month: "long",
//                           year: "numeric",
//                         })
//                       : "Unknown Date"}
//                   </strong>
//                 </p>
//                 <p>{note.notes || "No notes provided."}</p>
//               </div>
//             ))
//         ) : (
//           <p>No notes available.</p>
//         )}
//       </div>

//       {/* History Section */}
//       <div className="history">
//         <h4>History</h4>
//         {Array.isArray(data.history) && data.history.length > 0 ? (
//           data.history
//             .filter((historyItem) => historyItem !== null && historyItem !== undefined)
//             .map((historyItem, index) => (
//               <div key={index}>
//                 <p>
//                   <strong>
//                     {historyItem.agentName || "Unknown Agent"} -{" "}
//                     {historyItem.createdOn
//                       ? new Date(historyItem.createdOn).toLocaleDateString("en-GB", {
//                           day: "numeric",
//                           month: "long",
//                           year: "numeric",
//                         })
//                       : "Unknown Date"}
//                   </strong>
//                 </p>
//                 <p>{historyItem.notes || "No history notes provided."}</p>
//               </div>
//             ))
//         ) : (
//           <p>No history available.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Download;
